import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGroup2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M11.702 3.942a1.875 1.875 0 0 1 0 3.366 4.9 4.9 0 0 1-1.052 1.685q.112.007.225.007a3.375 3.375 0 1 0-.225-6.743c.457.48.818 1.05 1.051 1.685"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M7.125 7.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75m0 1.5a3.375 3.375 0 1 0 0-6.75 3.375 3.375 0 0 0 0 6.75",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M3.75 12h6.75a1.5 1.5 0 0 1 1.5 1.5v2.25h1.5V13.5a3 3 0 0 0-3-3H3.75a3 3 0 0 0-3 3v2.25h1.5V13.5a1.5 1.5 0 0 1 1.5-1.5m12 3.75h1.5v-1.5a3.75 3.75 0 0 0-3.38-3.732c.487.55.84 1.218 1.013 1.957.528.412.867 1.054.867 1.775z"
		})
	]
});
export default SvgGroup2;
